<template lang="pug">
    v-dialog(v-model="dialog" persistent scrollable max-width='600px' v-if="validDialog")
        v-card.mx-auto
            v-card-title Switch Customer's Campaign
            v-card-text
                v-container.mt-8.py-8.d-flex.flex-column.align-center.justify-center.switch-container

                    v-row.d-flex.flex-column.align-center(style="font-size: 16px;")
                        span Current Campaign: 
                        span.text-black {{ currentCampaignName }}

                    v-icon(
                        style="font-size: 75px;"
                        color='primary'
                    ) mdi-arrow-down-thin

                    div(style="width: 100%; max-width: 400px;")
                        v-autocomplete(
                            hide-details
                            :items='campaigns'
                            item-text='campaign_name'
                            item-value='campaign_id'
                            label='New Campaign *'
                            :loading="isLoading"
                            outlined
                            v-model='selectedCampaignID'
                        )

            v-card-actions.ma-2
                v-spacer
                v-btn(outlined @click='exit();')
                    v-icon mdi-close
                    | Cancel
                v-btn(
                    :disabled="!validSelectedCampaign"
                    :dark="validSelectedCampaign"
                    color='green'
                    @click='confirm();'
                )
                    v-icon mdi-content-save
                    | Confirm Switch

</template>

<script lang="ts">
    import Vue from 'vue';

    // Data
    import { GetCampaignCustomerOtherAvailableCampaigns } from "@/data";

    export default Vue.extend({
        data() {
            return {
                campaigns: [],
                dialog: true,
                isLoading: false,
                selectedCampaignID: null,
            }
        },
        methods: {
            confirm() {
                if (!this.validSelectedCampaign) {
                    return;
                }

                if (typeof this.switchCampaignForCampaignCustomerActive !== 'function') {
                    return;
                }

                this.switchCampaignForCampaignCustomerActive(this.selectedCampaignID);
                this.exit();
            },
            exit() {
                this.dialog = false;
                this.closeSwitchCampaign();
            },
            getCampaignCustomerOtherAvailableCampaigns() {

                // Init
                const options = {
                    account_id: this.currentCampaignCustomer?.account_id,
                }

                this.isLoading = true;
                GetCampaignCustomerOtherAvailableCampaigns(this.currentCampaignCustomer?.campaign_customer_active_id, options).then((response) => {
                    if (response?.Data?.campaigns?.length > 0) {
                        this.campaigns = response?.Data?.campaigns;
                    } else {
                        this.$emit("no-other-available-campaigns");
                    }

                    this.isLoading = false;
                });
            },
            isSelectedCampaign(campaignID) {
                return campaignID === this.selectedCampaignID;
            },
        },
        computed: {
            currentCampaignName() {
                return this.currentCampaignCustomer?.campaign_name;
            },
            validDialog() {
                return this.currentCampaignCustomer?.campaign_customer_active_id > 0 && this.currentCampaignCustomer?.account_id > 0;
            },
            validSelectedCampaign() {
                return this.selectedCampaignID > 0;
            },
        },
        components: {
        },
        props: {
            closeSwitchCampaign: Function,
            currentCampaignCustomer: Object,
            switchCampaignForCampaignCustomerActive: Function,
        },
        created() {
            this.getCampaignCustomerOtherAvailableCampaigns();
        },
    });
</script>

<style lang="scss" scoped>
.switch-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 1rem;
    }
</style>
